export default __webpack_public_path__ + "static/media/teamwork.44f828c3.svg";